import React from 'react';

import Heading, { HeadingProps } from '@/components/atoms/heading';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

export interface HeadingSBProps {
  text: string;
  level: HeadingProps['level'];
}

export default function HeadingSB({
  block,
}: BlockComponentModel<HeadingSBProps>) {
  return <Heading {...block}>{block.text}</Heading>;
}
